import { render, staticRenderFns } from "./send.vue?vue&type=template&id=7b1abb15&scoped=true&"
var script = {}
import style0 from "./send.vue?vue&type=style&index=0&id=7b1abb15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1abb15",
  null
  
)

export default component.exports